module.exports = __webpack_public_path__ + "img/Porto Apartment - 16 of 85.a72ff739.jpeg";